import { Center, Text } from '@mantine/core'

interface LiveScoreBoxProps {
  score?: string | number | null
}

/**
 * Port of cdc-web `Compact/_shared/LiveScoreBox.tsx`。
 * 差异：cdc-web 用 Text variant="subtitle-numbers"（cdc-market 不存在该 variant），
 * 改为 "subtitle-number"（cdc-market 单数命名），等宽数字特性
 * `fontFeatureSettings: '"lnum" 1, "tnum" 1'` 保留。
 *
 * 自隐藏：score 为 undefined / null / '' 时不渲染（'0' / 0 是真实比分，要渲染）。
 */
export function LiveScoreBox({ score }: Readonly<LiveScoreBoxProps>) {
  if (score === undefined || score === null || score === '') return null

  return (
    <Center
      w={32}
      px={4}
      style={{
        flexShrink: 0,
        borderRadius: 'var(--corner-radius-xs, 4px)',
        border: '1px solid var(--border-surface-default)',
        background: 'var(--bg-surface-app)',
      }}
    >
      <Text
        variant="subtitle-number"
        c="var(--content-primary)"
        style={{ fontFeatureSettings: '"lnum" 1, "tnum" 1' }}
      >
        {score}
      </Text>
    </Center>
  )
}
